/* eslint-disable no-nested-ternary */
import React, {memo, useEffect, useState} from 'react';

import {isEqual} from 'lodash';
import {Button} from 'react-bootstrap';
import {useDispatch, useSelector} from 'react-redux';

import * as manualControlActions from '@/actions/manualControlActions';
import * as modalActions from '@/actions/modalActions';
import {PostRequest} from '@/api/request';
import {PostStartManualUpdate, PostCancelManualControl} from '@/businesses/fetchManualControl';
import InputField from '@/components/inputfield/InputField';
import StandalonePopUp from '@/components/popup/StandalonePopUp';
import {RecoveryOfLiquidAction} from '@/constants/autoProfileEnum';
import * as APPDATA from '@/constants/pcConstAppData';
import {RecoveryOfLiquidEvent} from '@/constants/pubSubEnum';
import {eventBusObject} from '@/observers/eventBus';

const booleanParser = (value) => {
  switch (value) {
    case 'true':
    case 'True':
      return true;
    case 'false':
    case 'False':
      return false;
    default:
      return value;
  }
};

function ManualControlPopup() {
  const _bus = eventBusObject();
  const dispatch = useDispatch();
  const manualControlStore = useSelector((store) => store.manualControlStore, isEqual);
  const setupStore = useSelector((store) => store.setupStore, isEqual);
  const {currentVolume} = setupStore;
  const {VolumeInMl, RequestPendingManualControl, StatusManualControl, IsShowManualControlPopUp, IsHoldToRunActive} =
    manualControlStore;

  const [calculator, setCalculator] = useState({
    volumeToStartAt: APPDATA.EMPTY_FIELD,
    percentage: APPDATA.EMPTY_FIELD,
    stepSize: 2,
    bufferNeeded: APPDATA.EMPTY_FIELD,
    exchangeStepSize: APPDATA.EMPTY_FIELD,
    stepSizeVolume: APPDATA.EMPTY_FIELD,
    showWarning: false,
  });
  const [showPopup, setShowPopup] = useState(false);
  const [currVolume, setCurrVol] = useState(currentVolume);
  const [volInML, setVolInML] = useState(VolumeInMl);
  const [isDisableTextInput, setIsDisableTextInput] = useState(IsHoldToRunActive);
  const [isEnableStopButton, setIsEnableStopButton] = useState(
    booleanParser(StatusManualControl.IsManualControlRunning) && !IsHoldToRunActive,
  );
  const [isAvailableStopButton, setIsAvailableStopButton] = useState(false);
  const [isDisableHoldButton, setIsDisableHoldButton] = useState(
    booleanParser(StatusManualControl.IsManualControlRunning) && !IsHoldToRunActive,
  );
  const [isTargetOverCurrent, setIsTargetOverCurrent] = useState(false);
  const [holdThreeSec, setHoldThreeSec] = useState(false);
  const [stopHold, setStopHold] = useState(false);
  const [isPointerDown, setIsPointerDown] = useState(false);

  useEffect(() => {
    setIsDisableTextInput(IsHoldToRunActive);
  }, [IsHoldToRunActive]);

  useEffect(() => {
    if (!booleanParser(StatusManualControl.IsManualControlRunning)) {
      setIsAvailableStopButton(false);
    }
  }, [StatusManualControl.IsManualControlRunning]);

  useEffect(() => {
    setIsEnableStopButton(booleanParser(StatusManualControl.IsManualControlRunning) && !IsHoldToRunActive);
    setIsDisableHoldButton(
      (booleanParser(StatusManualControl.IsManualControlRunning) && !IsHoldToRunActive) ||
        booleanParser(RequestPendingManualControl),
    );
  }, [StatusManualControl.IsManualControlRunning, IsHoldToRunActive, RequestPendingManualControl]);

  useEffect(() => {
    setShowPopup(IsShowManualControlPopUp);
  }, [IsShowManualControlPopUp]);

  useEffect(() => {
    if (parseFloat(currentVolume) < currVolume) {
      if (holdThreeSec) {
        setHoldThreeSec(false);
      }
    }
    setCurrVol(parseFloat(currentVolume));
  }, [currentVolume]);

  useEffect(() => {
    setVolInML(parseFloat(VolumeInMl));
  }, [VolumeInMl]);

  useEffect(() => {
    if (volInML >= currVolume) {
      setIsTargetOverCurrent(true);
    } else {
      setIsTargetOverCurrent(false);
    }
  }, [currVolume, volInML]);

  const popUpButton = [
    {
      id: APPDATA.PROCEED_TO_RECOVERY,
      isPrimaryButton: false,
      onClick: () => onClickProceedToRecovery(),
      label: APPDATA.PROCEED_TO_RECOVERY,
      disabled: isDisableTextInput || isAvailableStopButton || isDisableHoldButton,
      className: 'recovery-button',
    },
  ];

  const bodyContent = (
    <div className="center">
      <span className="popUpManualControl">
        <div className="popUpGrid">
          <div className="popUpTop">
            <span>Safety Threshold Reached.</span>
            <span>Inspect current sample volume and continue manual concentration with the options below.</span>
          </div>
          <div className="popUpCenter">
            <div className="leftPosition">
              <p>Target Volume</p>
              <div className="concentrateField">
                <InputField
                  labelClassname="inputField none"
                  label={APPDATA.FIELD_NAME.TARGET_VOLUME}
                  classInputCollumn="inputField target"
                  inputValue={volInML}
                  unit={APPDATA.UNIT.ml}
                  onClick={(e) => onClickCalculator(e)}
                  hideField={undefined}
                  disabled={isDisableTextInput || isAvailableStopButton}
                />
              </div>
              {!isAvailableStopButton && (
                <button
                  type="button"
                  id="Concentrate"
                  className="button-green"
                  onClick={() => StartManualControl()}
                  disabled={isDisableTextInput || isTargetOverCurrent}
                >
                  CONCENTRATE
                </button>
              )}
              {isAvailableStopButton && (
                <button
                  type="button"
                  id="Stop"
                  className="button-red"
                  onClick={() => StopManualControl()}
                  disabled={!isEnableStopButton}
                >
                  STOP
                </button>
              )}
            </div>
            <div className="separator">
              <div className="line" />
              <div className="wordwrapper">
                <div className="word">or</div>
              </div>
            </div>
            <div className="rightPosition">
              <button
                type="button"
                // onClick={button1Props.onClick}
                id="Hold To Concentrate"
                className="button-secondary"
                disabled={isDisableHoldButton}
                onPointerDown={() => startLongPressAction()}
                onPointerUp={() => endLongPressAction()}
                onPointerLeave={() => endLongPressAction()}
              >
                <span
                  className="text-button center"
                  id="Hold To Concentrate"
                >
                  HOLD TO CONCENTRATE
                </span>
              </button>
            </div>
          </div>
          <div className="popUpButtom">
            <span>Current Sample Volume: {currVolume} mL</span>
          </div>
        </div>
      </span>
    </div>
  );

  const StartManualControl = () => {
    if (!RequestPendingManualControl) {
      setIsAvailableStopButton(true);
      const targetVol = (currVolume - volInML).toFixed(2);
      dispatch(manualControlActions.updateManualControlStartVolume(currVolume));

      const param = {
        TotRunTime: targetVol,
      };
      dispatch(PostStartManualUpdate(param));
    }
  };

  const endLongPressAction = () => {
    if (isPointerDown) {
      StopManualControlOnHold();
    }
  };

  const startLongPressAction = () => {
    setIsPointerDown(true);
    StartManualControlOnHold();
  };

  const StartManualControlOnHold = () => {
    if (IsHoldToRunActive === false) {
      setHoldThreeSec(true);
      dispatch(manualControlActions.updateIsHoldToRunActive(true));
      dispatch(manualControlActions.updateManualControlStartVolume(currVolume));
      if (!RequestPendingManualControl) {
        PostRequest(APPDATA.API.START_HOLD_TO_CONCENTRATE);
      }
      setTimeout(() => {
        setHoldThreeSec(false);
      }, 3000);
    }
  };

  useEffect(() => {
    if (!holdThreeSec && stopHold) {
      if (IsHoldToRunActive === true) {
        dispatch(manualControlActions.updateIsHoldToRunActive(false));
        dispatch(manualControlActions.updateManualControlStartVolume('0')); // reset value
        if (!RequestPendingManualControl) {
          PostRequest(APPDATA.API.STOP_HOLD_TO_CONCENTRATE);
        }
        setStopHold(false);
        setIsPointerDown(false);
      }
    }
  }, [holdThreeSec, stopHold]);

  const StopManualControlOnHold = () => {
    if (!holdThreeSec) {
      if (IsHoldToRunActive === true) {
        dispatch(manualControlActions.updateIsHoldToRunActive(false));
        dispatch(manualControlActions.updateManualControlStartVolume('0')); // reset value
        if (!RequestPendingManualControl) {
          PostRequest(APPDATA.API.STOP_HOLD_TO_CONCENTRATE);
        }
        setIsPointerDown(false);
      }
    } else {
      setStopHold(true);
    }
  };

  const StopManualControl = () => {
    setIsAvailableStopButton(false);
    if (!booleanParser(RequestPendingManualControl)) dispatch(PostCancelManualControl());
  };

  const onClickCalculator = (e) => {
    let value;
    let unit;
    const info = undefined;
    let maxValue = 0;
    let minValue = 100;
    const maxVal = currVolume;
    const minVal = APPDATA.CONFIGURATION.TARGET_VOLUME.MIN_VALUE;
    let maxDigitAfterDecimal = 0;
    let incrementValue = 1;

    switch (e.currentTarget.id) {
      case APPDATA.FIELD_NAME.TARGET_VOLUME:
        // dispatch(modalActions.hidePopUp());
        value = volInML;
        unit = APPDATA.UNIT.ml;
        maxValue = maxVal;
        minValue = minVal;
        maxDigitAfterDecimal = APPDATA.CONFIGURATION.TARGET_VOLUME.DECIMAL_PLACE_ACCURACY;
        incrementValue = APPDATA.CONFIGURATION.TARGET_VOLUME.INCREMENT_VALUE;
        break;
      default:
        break;
    }
    if (value === APPDATA.EMPTY_FIELD) value = '0';
    if (value !== undefined) {
      dispatch(
        modalActions.showModal({
          modalHeader: e.currentTarget.id,
          value,
          callback: onChangeCalculator,
          maxValue,
          minValue,
          maxDigitAfterDecimal,
          incrementValue,
          unit,
          info,
        }),
      );
    }
  };

  const onChangeCalculator = (e) => {
    const newCalculator = calculator;
    if (e.type) {
      switch (e.type) {
        case APPDATA.FIELD_NAME.TARGET_VOLUME:
          newCalculator.percentage = e.value;
          dispatch(manualControlActions.updateVolumeInMl(e.value));

          break;
        default:
          break;
      }

      setCalculator(newCalculator);
    }
  };

  const onClickProceedToRecovery = () => {
    if (StatusManualControl.IsManualControlEnable === 'true') {
      _bus.publish(RecoveryOfLiquidEvent.SHOW_POP_UP, {recoveryAction: RecoveryOfLiquidAction.STOP_MANUAL_CONTROL});
      closePopUp();
    } else {
      console.log('Error : Manual control is not enable');
    }
  };

  const generateButton = () => {
    const button = popUpButton
      ? popUpButton.map((button) => {
          const classButton = button.isPrimaryButton
            ? `primaryButton no-outline ${button.className}`
            : button.className
            ? `${button.className} no-outline `
            : 'secondaryButton no-outline ';
          return (
            <Button
              id={button.id}
              key={button.id}
              bsSize="large"
              className={classButton}
              onClick={button.onClick}
              disabled={button.disabled}
            >
              {button.label.toUpperCase()}
            </Button>
          );
        })
      : '';
    return button;
  };

  const closePopUp = () => {
    dispatch(manualControlActions.IsShowManualControlPopUp(false));
    dispatch(manualControlActions.IsShowManualControlAvailablePopUp(false));
    setShowPopup(false);
  };

  return (
    <StandalonePopUp
      isPopUpVisible={showPopup}
      contents={{
        popUpTitle: APPDATA.MESSAGES.MANUAL_CONTROL.TITLE,
        popUpBody: bodyContent,
        popUpFooter: (
          <div className="row">
            <div className="buttondiv centerdiv">{generateButton()}</div>
          </div>
        ),
      }}
      onClose={closePopUp}
      hideCloseButton
    />
  );
}
export default memo(ManualControlPopup);
